module.exports = __webpack_public_path__ + "img/四川大学-300x300.8ec7f1b2.jpeg";